import actionTypes from '../constants/actionTypes';

export const startGetSection = () => ({ type: actionTypes.START_GET_SECTION });

export const successGetSection = (section) => ({
  type: actionTypes.SUCCESS_GET_SECTION,
  section,
});

export const errorGetSection = (error) => ({
  type: actionTypes.ERROR_GET_SECTION,
  error,
});

export const getSection = (sectionLink) => {
  return async (dispatch) => {
    dispatch(startGetSection());
    try {
      const [section] = await (
        await fetch(
          `${process.env.REACT_APP_ENDPOINT}/sections?link=${sectionLink}`
        )
      ).json();
      dispatch(successGetSection(section));
    } catch (error) {
      dispatch(errorGetSection(error));
    }
  };
};
